import { Pipe, PipeTransform } from '@angular/core';

/**
 * Displays account name with correct casing.
 * If the name is all-uppercase (e.g. from DB), shows it in title case for readability.
 * Otherwise shows as-is (case-sensitive).
 */
@Pipe({ name: 'accountName' })
export class AccountNamePipe implements PipeTransform {
	transform(value: string | null | undefined): string {
		if (value == null) return '';
		// If name is all caps (and has at least one letter), show as title case
		if (/[A-Z]/.test(value) && !/[a-z]/.test(value)) {
			return value
				.toLowerCase()
				.replace(/\b\w/g, (c) => c.toUpperCase());
		}
		return value;
	}
}
